import { motion } from "framer-motion";
import { Phone, MessageCircle, CalendarHeart } from "lucide-react";
import { SITE } from "../config/site";

export const FloatingActions = ({ onBook }) => {
  return (
    <>
      <div className="fixed right-4 sm:right-6 bottom-24 md:bottom-8 z-40 flex flex-col gap-3">
        <motion.a
          data-testid="floating-whatsapp-button"
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
          whileHover={{ scale: 1.1 }}
          className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lift"
        >
          <MessageCircle size={24} aria-hidden="true" />
        </motion.a>
        <motion.a
          data-testid="floating-call-button"
          href={SITE.phoneHref}
          aria-label="Call Beauty Trendz Salon"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.75, type: "spring", stiffness: 260, damping: 18 }}
          whileHover={{ scale: 1.1 }}
          className="w-14 h-14 rounded-full bg-brand-green text-white flex items-center justify-center shadow-lift"
        >
          <Phone size={22} aria-hidden="true" />
        </motion.a>
      </div>

      <div
        data-testid="mobile-sticky-cta"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-brand-cream/95 border-t border-brand-green/10 px-4 py-3 grid grid-cols-3 gap-2.5"
      >
        <a
          data-testid="mobile-cta-call"
          href={SITE.phoneHref}
          className="flex items-center justify-center gap-2 rounded-full border border-brand-green py-3 text-sm font-semibold text-brand-green"
        >
          <Phone size={16} aria-hidden="true" />
          Call
        </a>
        <a
          data-testid="mobile-cta-whatsapp"
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 rounded-full bg-[#25D366] py-3 text-sm font-semibold text-white"
        >
          <MessageCircle size={16} aria-hidden="true" />
          WhatsApp
        </a>
        <button
          data-testid="mobile-cta-book"
          onClick={onBook}
          className="flex items-center justify-center gap-2 rounded-full bg-brand-gold py-3 text-sm font-semibold text-white"
        >
          <CalendarHeart size={16} aria-hidden="true" />
          Book
        </button>
      </div>
    </>
  );
};
